// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__RM6Fc","col":"Table_col__3NKKe","fulfillmentStatus":"Table_fulfillmentStatus__28tP0","emailCol":"Table_emailCol__7UJZl"};